<template>
    <div id="app">
        <PatientSummary :Mode="'Edit'" :Type="AppServiceID"/>
    </div>
</template>

<script>
import PatientSummary from '@/components/MedicalSupply/PatientSummary.vue'
import LayoutDefault from '../../Common/Default/DefaultLayout.vue';
export default {
    data: function (){
        return {
            AppServiceID :'', 
        }
    },
    components: { 
        PatientSummary
    },
created: function() {
    this.$emit('update:layout', LayoutDefault);
     this.AppServiceID= this.$store.getters.GetMedicalID; 

},   
beforeCreate: function() {
        this.$store.dispatch('AddServiceID',this.$store.getters.GetMedicalID);
        this.$store.dispatch('GetMenuItems',this.$store.getters.GetMedicalID);
    },
}
</script>

<style>

</style>
